export default __webpack_public_path__ + "static/media/default-avatar.b3477e97.jpg";